import React, { Fragment } from "react";
import { Dialog, DialogBackdrop, Transition, TransitionChild } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/solid";

export default function ModalWrapper({ children, open, setOpen }) {
  return (
    <Transition show={open} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-20 inset-0 overflow-y-auto"
        onClose={setOpen}
      >
        <div className="flex items-center justify-center h-full">
          {/* Gray screen behind modal */}
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>
          {/* Modal Wrapper (stays in one place) */}
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="absolute top-28 left-1/2 transform -translate-x-1/2  max-h-[75vh] overflow-auto no-scrollbar inline-block bg-white rounded-lg p-4 shadow-xl">
              <div
                className="flex justify-end mb-3"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpen(false);
                }}>
                <XMarkIcon className="w-5 stroke-gray-400 cursor-pointer hover:stroke-fluree-blue" />
              </div>
              <div className="flex-1">{children}</div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
}
